import { z } from 'zod';

export const chatContextSourceSchema = z.discriminatedUnion('kind', [
  z.object({
    kind: z.literal('PVI'),
    sectionTitle: z.string().optional(),
  }),
  z.object({
    kind: z.literal('DDX'),
    sectionTitle: z.string().optional(),
  }),
]);
export type ChatContextSource = z.infer<typeof chatContextSourceSchema>;

// Mastra's V5 UI→DB adapter drops part-level DataUIPart.id, so we keep it inside `data`.
export const chatContextDataSchema = z.object({
  id: z.string(),
  text: z.string(),
  source: chatContextSourceSchema,
  createdAt: z.string().datetime(),
});
export type ChatContextData = z.infer<typeof chatContextDataSchema>;

export const userContextDataPartSchema = z.object({
  type: z.literal('data-userContext'),
  data: chatContextDataSchema,
});
export type UserContextDataPart = z.infer<typeof userContextDataPartSchema>;

export const chatInputPartSchema = z.discriminatedUnion('type', [
  z.object({ type: z.literal('text'), text: z.string() }),
  userContextDataPartSchema,
]);
export type ChatInputPart = z.infer<typeof chatInputPartSchema>;

export type EluveChatDataTypes = {
  userContext: ChatContextData;
};
